<template>
  <el-dialog :title="title" class="sort-box" :visible.sync="showSort" width="560px" >
    <!-- 拖动表格 -->
    <el-table-draggable @onEnd="handleRowOnEnd">
      <el-table :data="list" height="365" stripe row-class-name="cursor-p"  row-key="guid" ref="groupSortTable" style="width: 100%">
        <el-table-column prop="deptName" label="分组名称">
        </el-table-column>
        <el-table-column label="操作" width="110">
          <template slot-scope="scope">
            <div class="opreateIcon">
              <img class="tags-drag" src="@/assets/images/drag.png" alt="" />
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-table-draggable>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmSort" size="small">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import ElTableDraggable from "el-table-draggable";
export default {
  components: {
    ElTableDraggable,
  },
  props: {
    list: {//列表数据
      type: Array,
      default: [],
    },
    title: {//标题
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showSort: false,
    };
  },
  methods: {
    // 行拖拽结束
    handleRowOnEnd() {
      setTimeout(() => {
        // 输出移动后每行的数据及索引
        this.list.forEach((row, index) => {
          this.$set(row, 'sort', index + 1)
        });
      }, 200);
      this.$forceUpdate()
    },
    //通知页面确定
    confirmSort(){
      this.$emit('sortEnd', this.list);
    },
  },
};
</script>
<style scoped>
.tags-drag {
  width: 20px;
  margin-top: 2px;
}
</style>
<style>
.cursor-p {
  cursor: pointer;
}
</style>